import React, { ChangeEvent, forwardRef } from 'react';
import { formatToPhone } from '~/utils/formatPhoneNumber';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  isScrolled?: boolean;
  borderColor?: string;
  handleOnChange?: (val: string) => void;
};

const GREEN = '#3BBFAD';

export const GetStartedInput = forwardRef<HTMLInputElement, Props>(
  function GetStartedInput(
    {
      isScrolled,
      borderColor,
      handleOnChange,
      className,
      style,
      type = 'tel',
      value,
      onChange,
      placeholder,
      ...rest
    },
    ref
  ) {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value;
      const formatted = type === 'tel' ? formatToPhone(raw) || '' : raw;
      handleOnChange?.(formatted);
      onChange?.(e);
    };

    const widthBase = isScrolled ? 'w-[224px]' : 'w-[286px]';
    const widthSmall = isScrolled ? 'small:w-[174px]' : 'small:w-[252px]';

    const classes = [
      // layout
      'box-border',
      'self-center',
      'overflow-hidden',
      'opacity-100',
      // size
      'h-14',
      widthBase,
      widthSmall,
      'desktop:w-[286px]',
      'rounded-[8px]',
      // typography
      'text-left',
      'text-[14px]',
      'placeholder:text-[14px]',
      'desktop:placeholder:text-[18px]',
      // base paddings
      isScrolled ? 'py-3 px-4' : 'p-6',
      // right padding for button spacing
      isScrolled ? 'pr-12' : 'pr-16',
      // small breakpoint adjustments
      isScrolled ? 'small:py-3 small:px-3 small:pr-8' : 'small:p-4 small:pr-12',
      // resets/appearance
      'appearance-none',
      'outline-0',
      'border'
    ];

    return (
      <input
        {...rest}
        ref={ref}
        type={type}
        value={value}
        onChange={handleChange}
        maxLength={type === 'tel' ? 14 : 320}
        placeholder={placeholder}
        className={[...classes, className || ''].join(' ')}
        style={{
          borderColor: borderColor || GREEN,
          WebkitTransform: 'translate3d(0, 0, 0)',
          transform: 'translate3d(0, 0, 0)',
          WebkitBackfaceVisibility: 'hidden',
          backfaceVisibility: 'hidden',
          transition: 'flex-grow 0.3s cubic-bezier(0, 0.7, 0.3, 1.01)',
          ...style
        }}
      />
    );
  }
);

export default GetStartedInput;
